export default __webpack_public_path__ + "images/89a341d4ad7b68d53c7d2422aab5a53f.png";